import { render } from "./Selector.vue?vue&type=template&id=077ec8a8"
import script from "./Selector.js?vue&type=script&lang=js"
export * from "./Selector.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__